<template>
    <FciDialog v-model="show" :title="title">
        <v-form ref="form" v-model="formValid" @submit="submit" class="TextEditor">
            <v-text-field
                outlined
                dense
                :rules="rules"
                v-model="text"
                autofocus
                :counter="maxLength > 0"
                :maxlength="maxLength > 0 ? maxLength : 1000000"
            ></v-text-field>
            <v-layout>
                <v-flex></v-flex>
                <v-btn color="primary" type="submit">{{ $f.capitalize($t(('save'))) }}</v-btn>
            </v-layout>
        </v-form>
    </FciDialog>
</template>

<script>
import FciDialog from '@/components/FciDialog'
import DialogPromiseFormMixin from '@/modules/fptai/mixins/DialogPromiseFormMixin'
import FormRules from '@/modules/fptai/utils/FormRules'

const defaultRules = [FormRules.ruleRequired]

export default {
    name: 'TextEditor',
    components: { FciDialog },
    mixins: [DialogPromiseFormMixin],
    data () {
        return {
            maxLength: 0,
            title: '',
            text: '',
            rules: []
        }
    },
    methods: {
        open ({
            text,
            title,
            maxLength,
            rules
        }) {
            this.title = title || this.$f.tc('name')
            this.text = text
            this.maxLength = maxLength || 0
            this.rules = rules || defaultRules
            console.log(this.rules)
            this.clearFormValidation()
            this.show = true
            return new Promise((resolve, reject) => {
                this.promise = {
                    resolve,
                    reject
                }
            })
        },
        submitValidForm () {
            this.close()
            this.promise.resolve(this.text)
        }
    }
}
</script>

<style scoped lang="scss">
.TextEditor {
    padding: 20px 10px 10px 10px;
}
</style>
